
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from '@/components/ui/select';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { DialogFooter } from '@/components/ui/dialog';
import { Organization } from '@/services/organizationService';
import { Assessment } from '@/types/assessment';

interface InviteToAssessmentFormProps {
  email: string;
  setEmail: (email: string) => void;
  fullName: string;
  setFullName: (fullName: string) => void;
  selectedOrganizationId: string;
  setSelectedOrganizationId: (id: string) => void;
  organizations: Organization[];
  loading: boolean;
  error: string;
  assessment: Assessment;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}

export function InviteToAssessmentForm({
  email,
  setEmail,
  fullName,
  setFullName,
  selectedOrganizationId,
  setSelectedOrganizationId,
  organizations,
  loading,
  error,
  assessment,
  onSubmit,
  onCancel
}: InviteToAssessmentFormProps) {
  return (
    <>
      {error && (
        <Alert variant="destructive">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      
      <form onSubmit={onSubmit}>
        <div className="grid gap-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email *</Label>
            <Input
              id="email"
              type="email"
              placeholder="user@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="fullName">Full Name</Label>
            <Input
              id="fullName"
              type="text"
              placeholder="John Smith"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="organization">Organization *</Label>
            <Select value={selectedOrganizationId} onValueChange={setSelectedOrganizationId} required>
              <SelectTrigger>
                <SelectValue placeholder="Select organization" />
              </SelectTrigger>
              <SelectContent>
                {organizations.map((org) => (
                  <SelectItem key={org.id} value={org.id}>
                    {org.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <Alert>
            <AlertDescription>
              The user will be invited to join the selected organization and receive direct access to the assessment "{assessment.title}".
            </AlertDescription>
          </Alert>
        </div>
        
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" disabled={loading}>
            {loading ? 'Sending Invitation...' : 'Send Assessment Invitation'}
          </Button>
        </DialogFooter>
      </form>
    </>
  );
}
